export type { CableWayCardProps } from "./cable-way-card";
export { CableWayCard } from "./cable-way-card";
